import { cx } from '@linaria/core';
import { useRef, useState, useEffect } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useCourseBuilder } from '@pm2/course-builder';
import { SpeechIcon, speechButtonSelectors } from '@ui/kit';
import { CSSRefTransition } from '@utils/react';
import { togglerCls, playerTransitionDurationMs, playerTransitionCls, playerContainerCls, playerCls } from './_toggler.styles.js';
import { AudioPlayer } from './audio-player.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function AudioPlayerToggler(props) {
  const togglerRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const showCourseBuilderPanel = useCourseBuilder(state => state.showPanel);

  // Ensure that audio-player stops playback in case the courseBuilderPanel is
  // opened as it will hide the UI
  useEffect(() => {
    if (showCourseBuilderPanel) {
      setExpanded(false);
    }
  }, [showCourseBuilderPanel]);
  if (!props.audioFile) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("button", {
      ref: togglerRef,
      className: cx(togglerCls, props.inLibrary && "inLibrary", showCourseBuilderPanel && "hidden", speechButtonSelectors.attachedAudioButton.className),
      onClick: () => setExpanded(true),
      children: [/*#__PURE__*/jsx(SpeechIcon, {}), "L\xE6s op"]
    }), /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: expanded && /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: playerTransitionCls,
        timeout: playerTransitionDurationMs,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: playerContainerCls,
          children: /*#__PURE__*/jsx("div", {
            className: cx(playerCls, speechButtonSelectors.attachedAudioPlayer.className),
            children: /*#__PURE__*/jsx(AudioPlayer
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            , {
              src: props.audioFile,
              onEnd: () => setExpanded(false)
            })
          })
        })
      })
    })]
  });
}

export { AudioPlayerToggler };
//# sourceMappingURL=_toggler.js.map
